import { AnalysisReportFileType, ReportMimeType } from '../models/reverse-engineering/analysis.models';

const REPORT = 'Report';
const DATA_TABLE = 'Data Table';
const MODEL = 'Data Model';
const DATA_VISUALIZATION = 'Data Visualization';

export const REPORT_FILE_TYPE = {
  PDF: REPORT,
  XLS: DATA_TABLE,
  XLSX: DATA_TABLE,
  XLSM: MODEL,
} as const;

export const ASSET_FILE_TYPE: {[t in ReportMimeType]: string} = {
  [ReportMimeType.PDF]: REPORT,
  [ReportMimeType.BLOG]: REPORT,
  [ReportMimeType.XLS]: DATA_TABLE,
  [ReportMimeType.XLSX]: DATA_TABLE,
  [ReportMimeType.XLSM]: MODEL,
  [ReportMimeType.XLSXO]: AnalysisReportFileType.XLSXO,
  [ReportMimeType.XXLS]: AnalysisReportFileType.XXLS,
  [ReportMimeType.QUICKSIGHT]: DATA_VISUALIZATION,
  [ReportMimeType.HYGRAPH]: REPORT,
} as const;
